import { render, staticRenderFns } from "./HseInspeccionGestiona.vue?vue&type=template&id=4ef988cf"
import script from "./HseInspeccionGestiona.vue?vue&type=script&lang=js"
export * from "./HseInspeccionGestiona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports